import { Link } from "@tanstack/react-router";
import { DocsSidebar } from "../DocsSidebar";
import { ArrowRight, UsersRound, Clipboard, Building2 } from "lucide-react";
import { groupedArticles } from "../docsContent";

/**
 * /docs landing — a short welcome plus every article grouped by audience, so a
 * signed-in user can browse without already knowing what they're looking for.
 */
export function DocsIndexPage() {
  const groups = groupedArticles();
  return (
    <div data-testid="docs-index" className="mx-auto max-w-3xl">
      <header className="mb-6">
        <p className="font-display text-[0.7rem] uppercase tracking-wider text-ink-muted">
          Help center
        </p>
        <h2 className="mt-1 font-display text-2xl font-semibold tracking-tight text-ink">
          A little help for the next step.
        </h2>
        <p className="mt-2 max-w-prose text-ink-muted">
          Step-by-step guides for watching matches, sharing and reviewing
          feedback, and running your club. Search above, or pick a topic below.
        </p>
      </header>

      <DocsSidebar searchOnly />
      <div className="docs-audience-grid">
        {groups.map(({ audience, articles }, index) => (
          <section key={audience.id} data-docs-group={audience.id}>
            <span className="docs-audience-icon">
              {index === 0 ? (
                <UsersRound />
              ) : index === 1 ? (
                <Clipboard />
              ) : (
                <Building2 />
              )}
            </span>
            <h3 className="mb-2 font-display text-[0.7rem] uppercase tracking-wider text-ink-muted">
              {audience.label}
            </h3>
            <ul className="grid gap-2 sm:grid-cols-2">
              {articles.map((a) => (
                <li key={a.slug}>
                  <Link
                    to="/docs/$slug"
                    params={{ slug: a.slug }}
                    data-testid={`docs-index-${a.slug}`}
                    className="group flex items-center justify-between gap-2 rounded border border-rule bg-surface px-3 py-2.5 text-sm shadow-sm transition-colors hover:border-accent hover:bg-field"
                  >
                    <span className="font-medium text-ink">{a.title}</span>
                    <ArrowRight className="size-4 shrink-0 text-ink-muted transition-transform group-hover:translate-x-0.5 group-hover:text-accent" />
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}
